import * as React from 'react';
import RequestHome from './request-home';
import { Request, NavigationProps } from 'lib/types';
import './data-stewardship.css';
import { DataTable, DataTableColumn, Tabs, TabsPanel, PageHeader } from '@salesforce/design-system-react';
import CustomerIcon from 'lib/CustomerIcon';
import LinkCell from 'lib/Overview/link-cell';
import PriorityGauge from './priority-gauge';
import PrivacyCell from './privacy-cell';
import Profile from './profile';
import Search from './search';
import { withBrandData } from 'lib/withBrand';

interface RequestsState {
	request?: Request;
	showProfile?: boolean;
	sources: Request[];	
}

interface RequestsProps extends NavigationProps {
	brandData: { profile: boolean };
	sources: Request[];
}

class Requests extends React.Component<RequestsProps, RequestsState> {
	constructor (props: RequestsProps) {
		super(props);
		this.state = {
			sources: props.sources
		};
	}

	showRequest = (request: Request) => {
		this.setState({ request });
	}

	showProfile = () => {
		this.setState({ showProfile: true });
	}

	navOverview = () => {
		this.setState({ request: undefined });
	}

	renderObject () {
		const request = this.state.request || {} as Request;
		return (
			<RequestHome
				navBack={this.navOverview}
				request={request}
			/>
		);
	}

	renderOverview () {
		const { sources } = this.state;
		return (
			<div className="stewardship-overview">
				<PageHeader
					icon={<CustomerIcon />}
					label=""
					title="Data Stewardship"
					variant="objectHome"
				/>
				<Tabs className="slds-m-around_medium">
					<TabsPanel label="Request Queue">
						<p className="slds-text-body_small">5 Requests • Sorted by Relevance</p>
					</TabsPanel>
					<TabsPanel label="Search" />
				</Tabs>
				<DataTable items={sources}>
					<DataTableColumn label="Priority" key="priority" property="priority">
						<PriorityGauge />
					</DataTableColumn>
					<DataTableColumn label="Request Type" key="type" property="type">
						<PrivacyCell />
					</DataTableColumn>
					<DataTableColumn label="Requestor" key="requestor" property="requestor" />
					<DataTableColumn label="Name" key="name" property="name" />
					<DataTableColumn label="Status" key="status" property="status" />
					<DataTableColumn label="Request Date" key="date" property="date" />
					<DataTableColumn label="Request ID" key="id" property="id">
						<LinkCell handleClick={this.showRequest} />
					</DataTableColumn>
				</DataTable>
			</div>
		);
	}

	render () {
		const showProfile = this.props.brandData.profile;

		if (showProfile) {
			return this.state.showProfile ? <Profile /> : <Search onClick={this.showProfile} />;
		} else {
			return this.state.request ? this.renderObject() : this.renderOverview();
		}
	}
}

export default withBrandData('stewardship', Requests);


// WEBPACK FOOTER //
// ./src/DataStewardship/index.tsx